export const HEX = 'hex';
export const HSL = 'hsl';
export const RGB = 'rgb';
export const CMYK = 'cmyk';
